<template>
  <div class="hero-content">
    <div class="loading" :class="{'-isloading': isLoading}"><img class="spin" src="@images/hero-animation/loading.png"></div>
    <div class="content-wrapper" :class="[{'-isloading': isLoading}]">
      <h2 class="page-title">
        <div
          v-for="(item,i) in randomHeroList"
          :key="i"
          class="page-title-text"
        >
          <img :src="require(`@images/series/${$route.params.lang}/txt_series-${item.seriesId}.png`)">
        </div>
      </h2>
      <div class="hero">
        <hero-image v-if="currentHero">
          <template v-slot:images>
            <div class="hero-image" v-for="(item,i) in randomHeroList" :key="i">
              <img :src="require(`@images/hero/faces/${item.id}.png`)" height="320" width="320">
            </div>
          </template>
        </hero-image>
        <hero-name class="hero-name-outer">
          <template v-slot:hero-name>
            <span class="name-text" v-for="(item,i) in randomHeroList" :key="i" v-html="item.name" />
          </template>
        </hero-name>
        <series-merge-notice
          v-if="currentHero && currentHero.isSamePerson"
          class="same_text"
          :hero="currentHero"
        />
      </div>
      <div class="buttons">
        <button @click="goToSelectType()">
          <img
            :src="require(`@images/common/${$route.params.lang}/btn_back.png`)"
            height="112"
            width="108"
          >
        </button>
        <button @click="nextHero" :class="[{'-disable': isVoted || termType !== 1}]">
          <img
            :src="require(`@images/hero/${$route.params.lang}/btn_next-hero.png`)"
            height="113"
            width="250"
          >
        </button>
        <button @click="showVoteConfirm" :class="[{'-disable': isVoted || termType !== 1}]">
          <img
            :src="require(`@images/hero/${$route.params.lang}/btn_vote-s.png`)"
            height="113"
            width="250"
          >
        </button>
      </div>
      <p class="note" v-if="isVoted && currentDay < 7" v-html="$t('text004')" />

      <sns-share share-text="footer.share.random" :replace-text="replaceText">
        <img :src="require(`@images/hero/${$route.params.lang}/txt_vote-share.png`)" />
      </sns-share>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Api from '@libraries/api/'
import RequestRandom from '@requests/random'
import ModelModal from '@models/modal'
import { validatelocale } from '@constants'

import HeroImage from '@components/hero/hero-image'
import HeroName from '@components/hero/hero-name'
import SeriesMergeNotice from '@components/global/vote-series-merge-notice'
import SnsShare from '@components/global/sns-share.vue'
import ModalVoteConfirm from '@components/modals/modal-vote-confirm'
import modalNALink from '@components/modals/modal-na-link'

import localeVote from '@locales/vote'

export default {
  name: 'random',
  $messages: localeVote,
  components: {
    HeroImage,
    HeroName,
    SeriesMergeNotice,
    SnsShare
  },
  data() {
    return {
      randomHeroList: [],
      currentIndex: 0,
      isLoading: true,
    }
  },
  created() {
    //MEMO: storeで保存しているisVotedのresetTime < 現在時間だったらリロードしてstoreをリセットする
    if (this.resetTime && new Date() > new Date(this.resetTime)) {
      location.reload();
    }
    this.getRandomHeroes()
  },
  mounted() {
    window.setTimeout(this.setIsLoading, 1000)
  },
  watch: {
    '$route.params.lang'(){
      this.getRandomHeroes()
    }
  },
  computed: {
    ...mapGetters('login', ['isLogin', 'isVoted', 'resetTime']),
    ...mapGetters('menu', ['termType', 'currentDay']),
    replaceText() {
      return { url: `${location.origin}/${this.$route.params.lang}/random` }
    },
    currentHero() {
      return this.randomHeroList ? this.randomHeroList[this.currentIndex] : null
    },
    modalVoteConfirm() {
      return new ModelModal({component: ModalVoteConfirm, props: this.currentHero})
    }
  },
  methods: {
    ...mapActions('modal', ['showModal']),
    async getRandomHeroes() {
      const cookieCheck = await validatelocale(this.$route.params.lang)
      //MEMO: cookie と path のlocaleが同じかどうかをチェック エラー時には強制リロード
      if (cookieCheck) {
        Api.call(new RequestRandom())
        .then((heroes) => {
          this.randomHeroList = heroes
        })
        .catch(({ error }) => {
          throw error
        })
      } else {
        location.reload()
      }
    },
    goToSelectType() {
      this.$router.push(`/${this.$route.params.lang}/select-type`)
      window.scrollTo(0, 0)
    },
    nextHero() {
      this.isLoading = true
      this.randomHeroList = this.getRandomHeroes()
      window.setTimeout(this.setIsLoading, 1000)
    },
    showVoteConfirm() {
      if (this.isLogin){
        this.showModal(this.modalVoteConfirm)
      } else {
        this.showModal(new ModelModal({
          component: modalNALink,
          props: {
            isModal: true,
            withoutLogin: this.modalVoteConfirm,
            redirectTo: `${location.origin}/${this.$route.params.lang}/series/${this.currentHero.seriesId}/heroes/${this.currentHero.id}`
          }
        }))
      }
    },
    setIsLoading() {
      this.isLoading = !this.isLoading
    },
  }
}
</script>

<style lang="scss" scoped>
@keyframes switch {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
@keyframes switch-last {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 1;
  }
}
@keyframes hero {
  0% {
    opacity: 0;
    transform: scale(1.8, 1.8);
  }
  50% {
    opacity: 1;
    transform: scale(1.5, 1.5);
  }
  100% {
    opacity: 0;
    transform: scale(1, 1);
  }
}
@keyframes hero-last {
  0% {
    opacity: 0;
    transform: scale(1.8, 1.8);
  }
  50% {
    opacity: 1;
    transform: scale(1.5, 1.5);
  }
  100% {
    opacity: 1;
    transform: scale(1, 1);
  }
}
@keyframes spin {
  0% {
    transform: rotate(0);
  }
  100% {
    transform: rotate(360deg);
  }
}
.hero-content {
  padding: 40px 0 0;
  box-sizing: border-box;
  > .loading {
    visibility: hidden;
    position: absolute;
    top: 340px;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin: 0 auto;
    background-image: url(#{$img-path}hero-animation/bg_loading.png);
    background-repeat: no-repeat;
    background-size: 410px auto;
    background-position: 50% 50%;
    &.-isloading {
      visibility: visible;
    }
    .spin {
      animation-name: spin;
      animation-duration: 2s;
      animation-timing-function: linear;
      animation-iteration-count: infinite;
      animation-fill-mode: forwards;
    }
  }
  > .content-wrapper {
    visibility: visible;
    opacity: 1;
    transition: opacity .25s ease-in;
    &.-isloading {
      visibility: hidden;
      opacity: 0;
    }
  }
}
.page-title {
  background-image: url(~@images/bg_page-title.png);
  background-repeat: no-repeat;
  background-size: 100% auto;
  position: relative;
  z-index: 1;
  height: 60px;
  width: 608px;
  margin: 0 auto;
  .page-title-text {
    position: absolute;
    width: 100%;
    height: 100%;
    opacity: 0;
    animation-name: switch;
    animation-duration: .2s;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
    > * {
      display: block;
      margin: 12px auto 0;
    }
    &:nth-child(1) {
      animation-name: switch-last;
      animation-delay: 1.9s;
    }
    &:nth-child(2) {
      animation-delay: 1.7s;
    }
    &:nth-child(3) {
      animation-delay: 1.5s;
    }
    &:nth-child(4) {
      animation-delay: 1.3s;
    }
    &:nth-child(5) {
      animation-delay: 1.1s;
    }
  }
}
.hero {
  padding: 0 40px 30px;
  margin-top: -60px;
  .hero-image {
    z-index: 3;
    opacity: 0;
    animation-name: hero;
    animation-duration: .2s;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
    &:nth-child(1) {
      animation-name: hero-last;
      animation-delay: 1.9s;
    }
    &:nth-child(2) {
      animation-delay: 1.7s;
    }
    &:nth-child(3) {
      animation-delay: 1.5s;
    }
    &:nth-child(4) {
      animation-delay: 1.3s;
    }
    &:nth-child(5) {
      animation-delay: 1.1s;
    }
  }
  .hero-name-outer {
    position: relative;
    width: 560px;
    height: 40px;
  }
  .name-text {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 60px;
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    animation-name: switch;
    animation-duration: .2s;
    animation-timing-function: linear;
    animation-fill-mode: forwards;
    &:nth-child(1) {
      animation-name: switch-last;
      animation-delay: 1.9s;
    }
    &:nth-child(2) {
      animation-delay: 1.7s;
    }
    &:nth-child(3) {
      animation-delay: 1.5s;
    }
    &:nth-child(4) {
      animation-delay: 1.3s;
    }
    &:nth-child(5) {
      animation-delay: 1.1s;
    }
  }
}
.same_text {
  color: $color-red;
  transition: all .1s linear 1.3s;
}
.buttons {
  display: flex;
  margin: 0 auto;
  justify-content: center;
  > * {
    @include tap-event();
  }
  > .-disable {
    opacity: .5;
    pointer-events: none,
  }
}
.note {
  text-align: center;
  margin-bottom: 40px;
}
.sns-share {
  margin-top: 30px;
  background-color: rgba(0, 0, 0, .5);
  padding-bottom: 50px;
}
</style>
